import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "./Infrastructures.css";
import L from "leaflet";
import gymnases from "../../assets/data/gymnases"

// Configuration de l'icône par défaut
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// Composant pour recentrer la carte
const RecenterMap = ({ position }) => {
    const map = useMap();

    useEffect(() => {
        if (position) {
            map.setView(position, 15, { animate: true }); // Recentre la carte avec animation
        }
    }, [position, map]);

    return null;
};

// Composant pour centrer les marqueurs
const MapBounds = ({ terrains }) => {
    const map = useMap();

    useEffect(() => {
        if (terrains && terrains.length > 0) {
            // Calcul des limites (bounds) des marqueurs
            const bounds = L.latLngBounds(
                terrains.map((terrain) => [terrain.latitude, terrain.longitude])
            );
            map.fitBounds(bounds, { padding: [50, 50] }); // Ajuste la carte avec un padding
        }
    }, [terrains, map]);

    return null;
};

const Infrastructures = () => {
    // Filtrer les terrains en amont pour initialiser l'état
    const filteredTerrains = gymnases.filter((terrain) => {
        return (
            terrain.latitude >= 47.0 &&
            terrain.latitude <= 47.5 &&
            terrain.longitude >= -1.7 &&
            terrain.longitude <= -1.3
        );
    });

    const [selectedTerrain, setSelectedTerrain] = useState(filteredTerrains.length > 0 ? filteredTerrains[0] : null);

    // Icône personnalisée rouge pour la sélection
    const redIcon = new L.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
    });

    const defaultIcon = new L.Icon.Default();

    return (
        <div className="infrastructures-section">
            <h2 className="infrastructures-title">Nos Infrastructures</h2>
            <p className="section-legend">
                Découvrez les gymnases où nous organisons nos entraînements et compétitions.
            </p>
            <div className="infrastructures-content">
                {/* Carte */}
                <div className="infrastructures-map">
                    <MapContainer
                        center={[47.218371, -1.553621]} // Coordonnées approximatives de Nantes
                        zoom={12}
                        className="map-container"
                    >
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution="&copy; OpenStreetMap contributors"
                        />
                        <MapBounds terrains={filteredTerrains} />

                        {filteredTerrains.map((terrain, index) => (
                            <Marker
                                key={index}
                                position={[terrain.latitude, terrain.longitude]}
                                icon={selectedTerrain === terrain ? redIcon : defaultIcon}
                                eventHandlers={{
                                    click: () => {
                                        setSelectedTerrain(terrain);
                                    },
                                }}
                            >
                                <Popup>
                                    <b>{terrain.name}</b>
                                    <br />
                                    {terrain.address}, {terrain.city}
                                </Popup>
                            </Marker>
                        ))}
                    </MapContainer>
                </div>

                {/* Liste des gymnases */}
                <div className="gym-list">
                    {filteredTerrains.map((terrain, index) => (
                        <div
                            key={index}
                            className={`gym-item ${selectedTerrain === terrain ? "active" : ""
                                }`}
                            onClick={() => setSelectedTerrain(terrain)} // Change le terrain sélectionné
                        >
                            <h3>{terrain.name}</h3>
                            <p>{terrain.address}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Infrastructures;
